import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $types } from './Ultraship.types'

@Injectable({ providedIn: 'root' })
export class Ultraship_parse_and_process_order_request_response_from_ultrashipService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { ultrashipOrderResponsePayload: string, messageTransactionId?: string }): Promise<{ outputDetails?: string[], requestResultResponse?: $types.Ultraship.OrderRequestResponse }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.ultrashipOrderResponsePayload)) {
      missingRequiredInParams.push('\'ultrashipOrderResponsePayload\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Ultraship/functions/parse_and_process_order_request_response_from_ultraship`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

